import React, { Fragment, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
// Actions
import { 
  searchContacts, 
  createContact, 
  updateContact, 
  deleteContact,
  searchCellCarriers,
  clearRedux 
} from "Redux/actions";
// Components
import Table from './components/table';
import CreateEditContact from './components/createEditContact';
import DeleteContact from './components/deleteContact';
import { NotificationManager } from 'Components/Notifications';

const ContactsView = (props) => {
  // Props
  const {
    intl: { messages },
  } = props;

  //local state
  const [showModalCreate, setShowModalCreate] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [newContact, setNewContact] = useState(null);
  const [contactDelete, setContactDelete] = useState(null);
  const [typeAction, setTypeAction] = useState("");
  // Hooks
  const dispatch = useDispatch();

  // State manager
  const { 
    registers,
    cellCarriers,
    loading, 
    allfilters, 
    formOptionsTypeSelected, 
    error,
    contact,
    deleteContactResponse
  } = useSelector(
    (state) => state.contactsRedux
  );

  useEffect(() => {
    formOptionsTypeSelected[0].name = messages['accountContacts_email']
    formOptionsTypeSelected[1].name = messages['accountContacts_cellphone']
  }, [messages])

  //Render view
  useEffect(() => {
    dispatch(searchCellCarriers());
  }, []);

  useEffect(() => {
    if (contact) {
      NotificationManager.success(
        messages[`accountContacts_${typeAction}Contact`],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );
      dispatch(
        searchContacts(allfilters)
      );
      setTypeAction("");
    }
  }, [contact]);

  useEffect(() => {
    if (deleteContactResponse) {
      setShowModalDelete(!showModalDelete);
      setContactDelete(null);
      setTypeAction("");
    }
  }, [deleteContactResponse]);

  useEffect(() => {
    if (error) {
      setNewContact(null);
      setContactDelete(null);
      setTypeAction("");
      deleteContactResponse && setShowModalDelete(!showModalDelete);
      dispatch(clearRedux("CONTACTS", { error: false }));
    }
  }, [error]);

  useEffect(() => {
    return () => {
      dispatch(clearRedux("CONTACTS"));
    }
  }, []);

  //type of action
  const onActions = (type, contactSelected) => {
    
    switch (type) {
      case 'Create':
          setShowModalCreate(!showModalCreate)
        break;
      case 'Edit':
          setNewContact({
            ...contactSelected,
            type: formOptionsTypeSelected.find((item) => item.id === contactSelected.type)
          });
          setShowModalCreate(!showModalCreate);
        break;
      case 'Editar':
          setNewContact({
            ...contactSelected,
            type: formOptionsTypeSelected.find((item) => item.id === contactSelected.type)
          });
          setShowModalCreate(!showModalCreate);
        break;
      case 'Eliminar':
          setContactDelete({
            id: contactSelected.id,
            title: contactSelected.title
          });
          setShowModalDelete(!showModalDelete);
        break;  
      case 'Delete':
          setContactDelete({
            id: contactSelected.id,
            title: contactSelected.title
          });
          setShowModalDelete(!showModalDelete);
        break;   
      default:
        break;
    }
  }

  const onSubmit = (type, contact) => {
    setTypeAction(type);
    if (type === "create") {
      dispatch(createContact({
        ...contact,
        message: messages['accountContacts_created']
      }));
    } else {
      dispatch(updateContact({
        ...contact,
        message: messages['accountContacts_updated']
      }));
    }
    setShowModalCreate(!showModalCreate);
    setNewContact(null);
  }

  return (
    <Fragment>
      <Table onActions={onActions} />
      {showModalCreate && <CreateEditContact
        messages={messages}
        showModal={showModalCreate}
        contact={newContact}
        cellCarriers={cellCarriers}
        optionsSelect={formOptionsTypeSelected}
        onCloseModal={() => {
          setShowModalCreate(!showModalCreate);
          setNewContact(null);
        }}
        onSubmit={onSubmit}
        loading={loading}
      />}
      
      <DeleteContact 
        messages={messages}
        contact={contactDelete}
        onShow={showModalDelete}
        loading={loading}
        onClose={(deleted) => {
          if (deleted === true) {
            dispatch(deleteContact({ 
              id: contactDelete.id,
              message: messages['accountContacts_deleted']
            }));
          } else {
            setShowModalDelete(!showModalDelete);
            setContactDelete(null);
          }
        }}
      />
    </Fragment>
  );
};

export default injectIntl(ContactsView);